module.exports = "<div class=\"fiesta-club-success-content\">\r\n  <div class=\"fiesta-club-success-title-container\">\r\n    <h1 class=\"fiesta-club-success-title\">Thank You!</h1>\r\n    <p>You're all set! We will be sending you amazing promos and ways to save at your favorite Rodrigo's locations!</p>\r\n    <button routerLink=\"/\" class=\"fiesta-club-success-btn rod-btn party-btn\">Back to Home Page</button>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/fiesta-club/success/success.component.html
// module id = ./src/app/fiesta-club/success/success.component.html
// module chunks = main